import React from 'react'
import { Field } from 'redux-form/immutable'

import Input from 'app/components/Input'
import ModalBody from 'app/components/Modal/ModalBody'
import ModalTitle from 'app/components/Modal/ModalTitle'
import { required } from 'helpers/validators'
import Button from 'app/components/ButtonDefault'
import CheckBox from 'app/components/CheckBox'

const isRequired = required()

const AddingLinkModal = ({ t, onRequestClose, handleSubmit, invalid, pristine }) => (
  <ModalBody onRequestClose={onRequestClose}>
    <ModalTitle>{t('Adding Link')}</ModalTitle>
    <form onSubmit={handleSubmit} style={{ paddingTop: '16px' }}>
      <Field name="text" component={Input} label={t('Display Text')} validate={[isRequired]} />
      <Field name="url" component={Input} label={'URL'} validate={[isRequired]} />
      <Field name="isOpenInNewTab" component={CheckBox} label={t(`Will open link in new user's tab?`)} />
      <Button type="submit" primary disabled={pristine || invalid}>
        {t('Insert link')}
      </Button>
    </form>
  </ModalBody>
)

export default AddingLinkModal
